<div class="absolute-full-container">
    <div class="absolute-toolbar">
        <app-info-bar (myExamsSelected)="handleMyExamsSelected()" (discussionsSelected)="handleDiscussionSelected()"
            (databaseSelected)="handleDatabaseSelected()" (registerCase)="handleCreateExam()" (userManagement)="handleUserManagement()"
            (integrationLog)="handleIntegrationLog()"
            (monitorExams)="handleMonitorExams()"></app-info-bar>
    </div>
    <div class="absolute-main-panel">
        <div class="router-container">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>